import { HomePageTile } from "slot-definitions"
import { Box } from "@mui/material"
import useLocalStorage from "minimals-template/components/@hooks/useLocalStorage"
import { useClientInfo } from "minimals-template/components/contexts/NognitoContext"
import Iconify from "minimals-template/components/Iconify"
import surveyBannerImg from "./survey-banner.png"

const BANNER_EXPIRY_DATE = new Date("2026-03-10")
const STORAGE_KEY = "customer-survey-banner-dismissed"
const SURVEY_BASE_URL = "https://survey.savanta.com/?&id=a2d40b2103&id2=979bcfd0&lng=en-GB&idp="

HomePageTile.plug(<SurveyBanner priority={80} />)

function SurveyBanner() {
    const [dismissed, setDismissed] = useLocalStorage(STORAGE_KEY, false)
    const clientInfo = useClientInfo()
    const clientId = clientInfo?.id?.split(":")[0] ?? ""

    if (new Date() > BANNER_EXPIRY_DATE) {
        return null
    }

    if (dismissed) {
        return null
    }

    const surveyUrl = `${SURVEY_BASE_URL}${encodeURIComponent(clientId)}`

    return (
        <Box mt={2} ml={2} width={1} position="relative">
            <Box
                component="a"
                href={surveyUrl}
                target="_blank"
                rel="noopener"
                sx={{
                    display: "block",
                    borderRadius: 2,
                    overflow: "hidden",
                    cursor: "pointer",
                    "&:hover": { opacity: 0.95 },
                }}
            >
                <Box
                    component="img"
                    src={surveyBannerImg}
                    alt="Complete our Customer Survey - Win 1 of 3 £250 prepaid Mastercard Gift Vouchers"
                    sx={{ width: 1, display: "block" }}
                />
            </Box>
            <Box
                onClick={handleDismiss}
                sx={{
                    position: "absolute",
                    top: 4,
                    right: 4,
                    cursor: "pointer",
                    color: "white",
                    bgcolor: "rgba(0,0,0,0.3)",
                    borderRadius: "50%",
                    width: 24,
                    height: 24,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    "&:hover": { bgcolor: "rgba(0,0,0,0.5)" },
                }}
            >
                <Iconify icon="mdi:close" width={16} height={16} />
            </Box>
        </Box>
    )

    function handleDismiss(e) {
        e.preventDefault()
        e.stopPropagation()
        setDismissed(true)
    }
}
